import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 10,
      paddingBottom: 40,
    },
    loadmore: {
      color: "#6B46E5",
      fontSize: 30,
    },
  })
);

export default useStyles;
